<!--
 * @Description: 主视口
 * @Author: your name
 * @Date: 2019-05-24 10:29:44
 * @LastEditTime: 2019-05-27 13:03:30
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="main-view-wrapper">
    <slide-bar />
    <div class="main-view-content">
      <header-nav />
      <div class="main-view-router-view">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import headerNav from '@/components/headerNav/index.vue'
import slideBar from '@/components/slideBar/index.vue'

export default {
  name: 'mainView',
  components: {
    headerNav,
    slideBar
  }
}
</script>

<style lang="scss" scoped>
.main-view-wrapper {
  display: flex;
  height: 100%;
  & > .main-view-content {
    flex: 1;
    overflow-x: hidden;
    & > .main-view-router-view {
      // padding-top: 10px;
    }
  }
}

</style>
